import API from '../API'
import SignCompanyRight from '../../models/Investor/Company'

export default class SignCompanyRightAPI extends API {
  public postSignCompanyRight(data: SignCompanyRight) {
    return this.post('api/company/signing-right-status', data)
  }
}
